import React, {useEffect, useState} from 'react';
import css from "../../main/Profile/Resume/Resume.module.scss";
import {CustomCheckBox} from "../../main/logbook/EditTable";
import {useTheme} from "../../../App";
import ReactTooltip from "react-tooltip";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getTrips} from "../../../redux/logbook/logbook-thunks";

const TripsTable = ({isEdit, setFieldValue, selectedCharters, charters, isInvite, isDark, getTrips, crewRoles}) => {
  const {t} = useTranslation()
  const [currentCharterCount, setCurrentCharterCount] = useState(5)
  useEffect(() => {
    getTrips({offset: currentCharterCount, roleIds: crewRoles.filter(r => r.name !== 'Crew-member').map(r => r.id), limit: 5})
  }, [])
  useEffect(() => {
    if(currentCharterCount % 10 === 0) getTrips({offset: currentCharterCount, roleIds: crewRoles.filter(r => r.name !== 'Crew-member').map(r => r.id), limit: 5})
  }, [currentCharterCount])
  return (
    <>
      {((!isEdit && selectedCharters.length !== 0) || isEdit) && <div
        className={`${css.resume__table} ${isInvite && css.resume__tableInvite} ${isDark && css.resume__tableDark}`}>
        <ul className={css.resume__row}>
          {!isInvite && <li className={`${css.resume__col} ${isEdit && 'pl-35'}`}>{t('charterCompany')}</li>}
          <li className={`${css.resume__col} ${isInvite && 'pl-35'}`}>{t('dates')}</li>
          <li className={css.resume__col}>{t('role')}</li>
          <li className={css.resume__col}>{t('sizeTypeBoat')}</li>
          {!isInvite && <li className={css.resume__col}>{t('nm')}</li>}
          {!isInvite && <li className={css.resume__col}>{t('days')}</li>}
          <li className={css.resume__col}>{t('sailingArea')}</li>
        </ul>
        {{charters: isEdit ? charters : charters.filter(c => selectedCharters.indexOf(c.id) !== -1)}.charters.slice(0, currentCharterCount).map((charter, index) =>
          <ul
            className={`${css.resume__row} ${selectedCharters.indexOf(charter.id) === -1 && `${css.resume__rowDisabled}`}`}
            key={index}>
            <li className={css.resume__col}>
              {isEdit && <>
                <CustomCheckBox isDark={isDark}
                                data-tip data-for={charter.id.toString()}
                                isChecked={selectedCharters.indexOf(charter.id) !== -1}
                                onClick={() => {
                                  if (selectedCharters.indexOf(charter.id) === -1) {
                                    setFieldValue('selectedCharters', [...selectedCharters, charter.id])
                                  } else {
                                    if (selectedCharters.length === 1) setFieldValue('isBareboat', false)
                                    setFieldValue('selectedCharters', [...selectedCharters].filter(s => s !== charter.id))
                                  }
                                }} marginBottom={'0px'}/>
                <ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={charter.id.toString()} place="top"
                              effect="solid">
                  {selectedCharters.indexOf(charter.id) !== -1 ? t('hideTripInResume') : t('showTripInResume')}
                </ReactTooltip>
              </>}
              <span
                className={isEdit && 'ml--22 mt--3'}>{isInvite ? `${charter.start_date} - ${charter.finish_date}` : charter.operator?.name}</span>
            </li>
            {!isInvite && <li className={css.resume__col}>{charter.start_date} - {charter.finish_date}</li>}
            <li className={css.resume__col}>{charter.role.name}</li>
            <li
              className={css.resume__col}>{charter.yacht_model?.name}{charter.yacht.year && `, ${charter.yacht.year}`}</li>
            {!isInvite && <li className={css.resume__col}>{charter.miles}</li>}
            {!isInvite && <li
              className={css.resume__col}>{(new Date(charter.finish_date) - new Date(charter.start_date)) / (24 * 3600 * 1000)}</li>}
            <li
              className={css.resume__col}>{charter.start_country?.name} {charter.start_country.name !== charter.finish_country?.name && `, ${charter.finish_country?.name}`}</li>
          </ul>)}
      </div>}
      <button onClick={() => setCurrentCharterCount(currentCharterCount + 5)} className={css.resume__showMore}>
        {t('showMoreCharters')}
      </button>
      {/*{(isEdit && currentCharterCount < charters.length) && <button onClick={() => setCurrentCharterCount(currentCharterCount + 5)} className={css.resume__showMore}>*/}
      {/*  {t('showMoreCharters')}*/}
      {/*</button>}*/}
    </>
  );
};

const mapStateToProps = (state) => ({
  crewRoles: state.dataReducer.crewRoles
})

export default connect(mapStateToProps, {getTrips})(React.memo(TripsTable))
